import { fetchMediaUrl } from '@/lib/media';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export function useSignedMediaUrl() {
  const queryClient = useQueryClient();

  const getSignedUrl = useCallback(
    async (url: string | null | undefined): Promise<string | null> => {
      if (!url) {
        return null;
      }

      try {
        const signedUrl = await queryClient.fetchQuery({
          queryKey: ['media-item', url],
          queryFn: () => fetchMediaUrl(url),
          staleTime: Number.POSITIVE_INFINITY,
          gcTime: 24 * 60 * 60_000,
        });
        return signedUrl;
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Failed to fetch signed URL');
        console.warn('Failed to fetch signed media URL:', error);
        throw error;
      }
    },
    [queryClient],
  );

  return { getSignedUrl };
}
